import { observable, action, makeObservable } from 'mobx';
import { InputType, ISelectValueType, ValueType } from './types';

export class AssetListInput implements InputType {
  dataType: string;

  label: string;

  placeholder?: string;

  tag: string;

  @observable selectorValue!: ValueType<ISelectValueType> | undefined;

  @observable value!: Record<string, any>[];

  error: string;

  @observable disabled: boolean;

  required: boolean;

  route: string = '';

  isKey: boolean = false;

  isEdit: boolean = false;

  constructor({
    tag,
    label,
    placeholder,
    dataType,
    error,
    disabled,
    required,
    route = '',
    isKey = false,
    isEdit = false,
  }: InputType) {
    this.dataType = dataType;
    this.label = label;
    this.tag = tag;
    this.placeholder = placeholder;
    this.error = error;
    this.disabled = disabled;
    this.required = required;
    this.route = route;
    this.isKey = isKey;
    this.isEdit = isEdit;
    makeObservable(this);
    this.onChange([]); // set initial value
  }

  // For assetList, onChange do not change the value, only the selecion
  @action
  onChange = (v: ValueType<ISelectValueType> | null) => {
    this.selectorValue = v;
  };

  // onChangeValue changes the assetArray
  @action
  onChangeValue = (v: Record<string, any>[]) => {
    this.value = v;
  };

  @action
  clearValue = () => {
    this.selectorValue = null;
    this.value = [];
  };

  @action
  toggleDisabled = () => {
    this.disabled = !this.disabled;
  };
}
